module.exports = __webpack_public_path__ + "img/topup-card2.99994e27.svg";